import React, { FC, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router";
import { Tabs } from "../../../components";
import {
  Container,
  HeadWrapper,
  TabsRow,
  Title,
} from "./styles";
import UsersTab from "./components/UsersTab";
import GroupsTab from "./components/GroupsTab";

const Authorization: FC = () => {
  const [t] = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<string>("users");

  const tabs = useMemo(
    () => [
      {
        title: t("AUTHORIZATION_USERS_TAB"),
        slug: "users",
        id: "users",
      },
      {
        title: t("AUTHORIZATION_GROUPS_TAB"),
        slug: "user-groups",
        id: "groups",
      },
    ],
    [t]
  );

  useEffect(() => {
    const lastSegment = location.pathname.split("/").pop();
    const found = tabs.find((item) => item.slug === lastSegment);
    if (found) {
      setActiveTab(found.slug);
    }
  }, [location.pathname, tabs]);

  return (
    <Container>
      <HeadWrapper>
        <Title>{t("AUTHORIZATION_SETTINGS")}</Title>
      </HeadWrapper>
      <TabsRow>
        <Tabs
          tabs={tabs}
          size="display"
          blockNavigate
          location={activeTab}
          onChange={(slug) => navigate(`/settings/authorization/${slug}`)}
        />
      </TabsRow>
      <Routes>
        <Route path="/" element={<Navigate replace to="users" />} />
        <Route path="/users" element={<UsersTab />} />
        <Route path="/user-groups" element={<GroupsTab />} />
      </Routes>
    </Container>
  );
};

export default Authorization;
